import { getUrls } from "./plugins/config.ts"
import { domain } from "./environment";
import store from "./core/redux/store.jsx";
import { setTranslations, setLangChange } from "./core/redux/action.jsx";

const parseCSV = (csvData) => {
  const lines = csvData.trim().split("\n");
  const headers = lines[0].split(",");
  
  return lines.slice(1).map((line) => {
    const values = line.split(",");
    return headers.reduce((acc, header, index) => {
      acc[header.trim()] = values[index]?.trim() || "";
      return acc;
    }, {});
  });
};

const fetchCSVData = async (url) => {
  try {
    const response = await fetch(url);
    const csvData = await response.text();
    console.log('csvData',csvData)
    return parseCSV(csvData);
  } catch (error) {
    console.error("Error fetching CSV data:", error);
    throw error;
  }
};

// export const getAppsTranslation = () => {
//   const url = "https://docs.google.com/spreadsheets/d/12GF82KCEnGbrySPgf7BiStQAM7hZR0qz4SgIPgDlVVU/pub?gid=0&single=true&output=csv";
//   return fetchCSVData(url);
// };
const transformData = (data) => {
  const result = { languages: [] };
  const processLanguage = (item, languageKey, parentName) => {
    const languageName = languageKey.split('-')[0].toLowerCase();
    // const language = languageKey.split('-')[1].toLowerCase();
    if (!result[languageName]) {
      result[languageName] = {};
      result.languages.push({ key: languageName, name: languageName.charAt(0).toUpperCase() + languageName.slice(1) });
    }

    item[languageKey].forEach(entry => {
      result[languageName][parentName] = entry.name;
      Object.keys(entry).forEach(key => {
        if (key !== 'name') processLanguage(entry, key, parentName);
      });
    });
  };
  data.forEach(item => {
    Object.keys(item).forEach(key => {
      if (key !== 'name') processLanguage(item, key, item.name);
    });
  });

  return result;
};

export const appTranslation = async () => {
  try {
    //const translations = await getAppsTranslation();
    const translationUrl = getUrls().translationLink;//"https://docs.google.com/spreadsheets/d/12GF82KCEnGbrySPgf7BiStQAM7hZR0qz4SgIPgDlVVU/pub?gid=650315180&single=true&output=csv";//translations.find((item) => item.web === domain)?.["translation"];
    // const translationUrl = '/assets/translation/translation.csv';//"https://docs.google.com/spreadsheets/d/12GF82KCEnGbrySPgf7BiStQAM7hZR0qz4SgIPgDlVVU/pub?gid=650315180&single=true&output=csv";//translations.find((item) => item.web === domain)?.["translation"];
    if (translationUrl) {
      // const data = await fetchCSVData(translationUrl);
      const data = await fetch(getUrls().translationLink);
      const data2 = await data.json();
      store.dispatch(setTranslations(transformData(data2['translate-key'])));
      const lang = localStorage.getItem("lang") || 'en';
      store.dispatch(setLangChange(lang));
      // console.log("Res:",data2);
      // console.log("Res1:",transformData(data2['translate-key']));
      return [];
      // console.log('Translation data',data);
      // const formattedData = formatTranslationData(data);
      // console.log("Final Translation Data:", formattedData);
      // return formattedData;
    } else {
      console.warn(`No translation URL found for domain: ${domain}`);
    }
  } catch (error) {
    console.error("Error in appTranslation:", error);
  }
};

const cleanKey = (key) => key.replace(/\r$/, "").trim();

// const formatTranslationData = (dataArray) => {
//   return dataArray.reduce((acc, item) => {
//     const key = item.key;
//     if (key) {
//       acc[key] = {};
//       Object.keys(item).forEach((itemKey) => {
//         if (itemKey !== "key") {
//           const cleanedKey = cleanKey(itemKey).split("-")[0];
//           acc[key][cleanedKey] = item[itemKey]?.trim() || "";
//         }
//       });
//     }
//     return acc;
//   }, {});
// };